
// services/admin/api.js

import axiosInstance from "../../../services/axiosInstance";

export const fetchAdminNotifications = async () => {
    const res = await axiosInstance.get("/admin/notification/all");
    return res.data.data;
};



// Get unread notification count
export const fetchAdminUnreadCount = async () => {
    const res = await axiosInstance.get("/admin/notification/unread-count");
    return res.data.data;
};

// Mark a single notification as read
export const markAdminNotificationAsRead = async (id) => {
    const res = await axiosInstance.put(
        `/admin/notification/${id}/read`
    );
    return res.data.data;
};

// Mark all notifications as read
export const markAllAdminNotificationsAsRead = async () => {
    const res = await axiosInstance.put(
        "/admin/notification/mark-all-read"
    );
    return res.data.data;
};

// (Optional) Get last 7 days notifications
export const fetchLast7DaysAdminNotifications = async () => {
    const res = await axiosInstance.get(
        "/admin/notification/last7days"
    );
    return res.data.data;
};

// (Optional) Save notification
export const saveAdminNotification = async (payload) => {
    const res = await axiosInstance.post(
        "/admin/notification/save",
        payload
    );
    return res.data;
};

// (Optional) Test endpoint
export const testAdminNotification = async () => {
    const res = await axiosInstance.get(
        "/admin/notification/test"
    );
    return res.data;
};


// Fetch Admin Activity Feed
export const fetchAdminActivityFeed = async () => {
    const res = await axiosInstance.get("/admin/activity/feed");
    return res.data;
};